// import config from "../config/config";
import config from "../../config";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import * as ACTIONTYPES from "../../redux/actionTypes";
import { useEffect, useState } from "react";
import { GoArrowRight } from "react-icons/go";

const DashboardMenus = () => {
  const navigate = useNavigate();
  const url = new URL(window.location.href);
  const lastPart = url.pathname.split("/").pop();

  const dispatch = useDispatch();
  const loginDetails = useSelector((state) => state.auth.LoginDetails);
  const walletConnnected = useSelector((state) => state.auth.walletConnnected);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const LogOut = () => {
    dispatch({ type: ACTIONTYPES.walletConnnected, payload: "" });
    dispatch({ type: ACTIONTYPES.USERLOGIN, payload: [], token: [] });
    navigate(`${config.Exchange}`);
  };
  useEffect(() => {
    console.log(walletConnnected, loginDetails, "walleta");
    if (loginDetails.length == 0) {
      navigate(`${config.Exchange}`);
    }
  }, [walletConnnected]);

  useEffect(() => {
    if (Object.keys(loginDetails).length == 0) {
      navigate(`${config.baseurl}`);
    }
  }, [loginDetails])


  return (
    <ul className="appsidebar me-auto">
      <li
        className={`${lastPart == "dashboard" || lastPart == "" ? "active" : ""
          }`}
      >
        <Link to={`${config.LaunchApp}dashboard`} className="nav-link ">
          <span>
            <img
              // src="assets/icons/Home1.png"
              src={`${lastPart == "dashboard"
                ? "assets/icons/homeIcon.svg"
                : "assets/icons/Home1.png"
                }`}
              width=""
              alt="bitcoin-card"
              className="sidemenuIcon"
            />
          </span>
          My INFI/Profit
        </Link>
      </li>
      <li className={`${lastPart == "swap" ? "active" : ""}`}>
        <Link to={`https://launchpad.infimultichain.com/`} target="_blank" className="nav-link ">
          <span>
            <img
              src={`${lastPart == "swap"
                ? "assets/icons/Swap.png"
                : "assets/icons/swapIcon.svg"
                }`}
              width="29px"
              alt="swapIcon"
              className="sidemenuIcon"
            />
          </span>
          Launchpad/Trade
        </Link>
      </li>
      <li
        className={`${lastPart == "simplestaking" ? "active" : ""}`}
      // onMouseEnter={toggleDropdown}
      // onMouseLeave={toggleDropdown}
      >
        <Link to={`${config.LaunchApp}simplestaking`} className="nav-link ">
          <span>
            <img
              src={`${lastPart == "simplestaking"
                ? "assets/icons/Stacking1.png"
                : "assets/icons/stackingIcon.svg"
                }`}
              //   src="assets/icons/stackingIcon.svg"
              width=""
              alt="stackingIcon"
              className="sidemenuIcon"
            />
          </span>
          INFI Staking
        </Link>
      </li>
      <li>
        <Link to={`https://infimultichain.com/ico/`} target="_blank" className="nav-link ">
          <span>
            <img
              src={`${lastPart == "swap"
                ? "assets/icons/Swap.png"
                : "assets/icons/ico.svg"
                }`}
              width="29px"
              alt="swapIcon"
              className="sidemenuIcon"
            />
          </span>
          INFI ICO
        </Link>
      </li>
      <li 
       onMouseEnter={toggleDropdown}
       onMouseLeave={toggleDropdown}>
        <Link to={``} target="_blank" className="nav-link ">
          <span>
            <img
              src={`${lastPart == "swap"
                ? "assets/icons/Swap.png"
                : "assets/icons/settingIcon.svg"
                }`}
              width="29px"
              alt="swapIcon"
              className="sidemenuIcon"
            />
          </span>
          SbSe Upcoming Upgrade

        </Link>
        {isDropdownOpen && (
          <ul className="dropdown-menu">
            <li><GoArrowRight/>&nbsp;Automated Market Maker</li>
            <li><GoArrowRight/>&nbsp;INFI CDEX Exchange Special Listings Features</li>
            <li><GoArrowRight/>&nbsp;INFI Blockchain</li>
            <li><GoArrowRight/>&nbsp;INFI Digital Hybrid eWallet</li>
            <li><GoArrowRight/>&nbsp;INFI eBank</li>
            <li><GoArrowRight/>&nbsp;Wear To Earn - Metaverse game</li>
          </ul>
        )}
      </li>
      {
        Object.keys(loginDetails).length > 0 ? (
          <li className="">
            <Link
              to=""
              className="nav-link "
            >
              <span
                style={{
                  fontWeight: "500",
                  cursor: "pointer",
                }}
                onClick={LogOut}
              >
                <img
                  src="assets/icons/logoutIcon.svg"
                  width=""
                  alt="logoutIcon"
                  className="sidemenuIcon me-3"
                />
                Logout
              </span>
            </Link>
          </li>
        ) : (
          ""
        )
      }
      <li>
        <Link to={`https://infimultichain.com/`}className="nav-link ">
          <span>
            <img
              src="assets/icons/homeIcon.svg"
              width="29px"
              alt="swapIcon"
              className="sidemenuIcon"
            />
          </span>
          Main Page
        </Link>
      </li>
    </ul >
  );
};
export default DashboardMenus;
